import { of } from 'rxjs';

export class TrackerStub {
  onContentUpdate = of(null);
  getChildTracker() {
    return new TrackerStub();
  }
  load() {}
}
